import { defineStore } from "pinia"
import { ref } from "vue"

export const useLeaveWindowModalStore = defineStore("leaveWindowModal", () => {
  const isActive = ref<boolean>(false)
  const leaveWindowCount = ref<number>(0)
  const modalShown = ref<boolean>(false)

  function incrementLeaveWindowCount() {
    leaveWindowCount.value++
    if (!modalShown.value) {
      isActive.value = true
      modalShown.value = true
    }
  }

  return {
    isActive,
    leaveWindowCount,
    incrementLeaveWindowCount,
  }
})
